import { _ as _extends } from './PokusReactHOC-bc27437b.esm.js';

var adobeTrack = function adobeTrack(eventName, eventProperties) {
  if (window.adobeDataLayer) {
    if (eventName === 'ctaClick') {
      // eslint-disable-next-line no-param-reassign
      eventProperties.cta = {
        name: eventProperties.cta.name || undefined,
        destination: eventProperties.cta.destination || undefined,
        type: eventProperties.cta.type || undefined,
        componentName: eventProperties.cta.componentName || undefined
      };
    }
    window.adobeDataLayer.push(_extends({
      event: eventName
    }, eventProperties));
  }
};

export { adobeTrack as a };
